/**
 *
 * 懒加载动态路由
 */
function lazy(code) {
  //return  resolve => require(["@/components/" + name + ".vue"], resolve)
  return getComponetByPath('/' + code);
}

function getComponetByPath(path) {
  for (var i = 0; i < dynamicRouter.length; i++) {
    var route = dynamicRouter[i];
    if (route.path == path) {
      return route.component;
    }
  }
}
/**
 * 路由定义
 * path跟配置里的资源标示对应,同时跟url地址对应
 */
const dynamicRouter = [


  {
    name: 'freezeCustomer',
    path: '/freezeCustomer',
    component: resolve => require(['@/components/customer/freeze.vue'], resolve),
    meta: {
      title: '客户回收站'
    }
  },


// 结算管理
{
  name:'settlementList',
  path:'/settlementList',
  component: resolve => require(['@/components/settlement/settlementList.vue'], resolve),
  meta:{title:'结算列表'}
},
// 广告管理
{
  name:'advert',
  path:'/advert',
  component: resolve => require(['@/components/settlement/advert.vue'], resolve),
  meta:{title:'广告管理'}
},

  {
    name: 'myCustomer',
    path: '/myCustomer',
    component: resolve => require(['@/components/customer/myCustomer.vue'], resolve),
    meta: {
      title: '我的客户'
    }
  },
  {
    name: 'inviteList',
    path: '/inviteList',
    component: resolve => require(['@/components/customer/inviteList.vue'], resolve),
    meta: {
      title: '邀请列表'
    }
  },
  {
    name: 'logoutList',
    path: '/logoutList',
    component: resolve => require(['@/components/logout/logoutList.vue'], resolve),
    meta: {
      title: '注销列表'
    }
  },



  //订单回收站
  {
    name:'orderRecycle',
    path:'/orderRecycle',
    component:resolve => require(['@/components/order/orderRecycle.vue'], resolve),
    meta:{
      title:'订单回收站'
    }
  },


//财务管理

 // 结算管理
{
  name:'settlementList',
  path:'/settlementList',
  component: resolve => require(['@/components/settlement/settlementList.vue'], resolve),
  meta:{title:'结算列表'}
},
// 订单结算
{
  name:'orderSettlement',
  path:'/orderSettlement',
  component: resolve => require(['@/components/settlement/orderSettlement.vue'], resolve),
  meta:{title:'订单结算'}
},
//企业审核
{
  name:'companyAudit',
  path:'/companyAudit',
  component: resolve => require(['@/components/settlement/companyAudit.vue'], resolve),
  meta:{title:'企业审核'}
},
//保证金列表
{
  name:'earnest',
  path:'/earnest',
  component: resolve => require(['@/components/settlement/earnest.vue'], resolve),
  meta:{title:'保证金'}
},



  // 网站管理
  {
    name:'banner',
    path:'/banner',
    component:resolve => require(['@/components/website/banner.vue'], resolve),
    meta:{
      title:'banner管理'
    }
  },
  {
    name:'phoneSet',
    path:'/phoneSet',
    component:resolve => require(['@/components/website/phoneSet.vue'], resolve),
    meta:{
      title:'电话设置'
    }
  },
  {
    name:'footSite',
    path:'/footSite',
    component:resolve => require(['@/components/website/footSite.vue'], resolve),
    meta:{
      title:'banner管理'
    }
  },
  {
    name:'sysMsg',
    path:'/sysMsg',
    component:resolve => require(['@/components/website/sysMsg.vue'], resolve),
    meta:{
      title:'系统消息'
    }
  },
  {
    name:'column',
    path:'/column',
    component:resolve => require(['@/components/website/column.vue'], resolve),
    meta:{
      title:'资讯栏目'
    }
  },
  {
    name:'article',
    path:'/article',
    component:resolve => require(['@/components/website/article.vue'], resolve),
    meta:{
      title:'资讯文章'
    }
  },

  {
    name:'question',
    path:'/question',
    component:resolve => require(['@/components/website/question.vue'], resolve),
    meta:{
      title:'常见问题'
    }
  },
  {
    name:'helpColumn',
    path:'/helpColumn',
    component:resolve => require(['@/components/website/helpColumn.vue'], resolve),
    meta:{
      title:'帮助栏目'
    }
  },
  {
    name:'helpDetails',
    path:'/helpDetails',
    component:resolve => require(['@/components/website/helpDetails.vue'], resolve),
    meta:{
      title:'帮助内容'
    }
  },
  {
    name:'agreeColumn',
    path:'/agreeColumn',
    component:resolve => require(['@/components/website/agreeColumn.vue'], resolve),
    meta:{
      title:'协议栏目'
    }
  },
  {
    name:'agreeDetails',
    path:'/agreeDetails',
    component:resolve => require(['@/components/website/agreeDetails.vue'], resolve),
    meta:{
      title:'协议内容'
    }
  },




  //广告管理
  {
    name:'advertmanage',
    path:'/advertmanage',
    component:resolve => require(['@/components/advert/advertmanage.vue'], resolve),
    meta:{
      title:'广告管理'
    }
  },
  //广告费
  {
    name:'advertFee',
    path:'/advertFee',
    component:resolve => require(['@/components/advert/advertFee.vue'], resolve),
    meta:{
      title:'广告费'
    }
  },

//******************************无形资产******************************

//******************************伯虎******************************
//首页
{
  name: 'index',
  path: '/index',
  component: resolve => require(['@/components/index.vue'], resolve),
  meta: {
    title: '首页'
  }
},


//组织机构
{
  name: 'OrganizationTree',
  path: '/organizationTree',
  component: resolve => require(['@/components/admin/OrganizationTree.vue'], resolve),
  meta: { title: '机构管理' }
},
{
  name: 'SysMenu',
  path: '/sysMenu',
  component: resolve => require(['@/components/admin/SysMenu.vue'], resolve),
  meta: { title: '菜单管理' }
},
{
  name:'SmsConfigure',
  path:'/smsConfigure',
  component:resolve => require(['@/components/admin/SmsConfigure.vue'], resolve),
  meta:{
    title:'短信配置'
  }
},

{
    name:'systemLog',
    path:'/systemLog',
    component:resolve => require(['@/components/admin/systemLog.vue'], resolve),
    meta:{
      title:'系统日志'
    }
},

//订单管理
{
  name:'orderList',
  path:'/orderList',
  component: resolve => require(['@/components/order/orderList.vue'], resolve),
  meta:{title:'订单列表'}
},



// 纠纷单列表
{
  name:'dispute',
  path:'/dispute',
  component: resolve => require(['@/components/order/dispute.vue'], resolve),
  meta:{title:'纠纷单列表'}
},
//自营订单管理
{
  name:'ownOrderList',
  path:'/ownOrderList',
  component: resolve => require(['@/components/order/orderList.vue'], resolve),
  meta:{title:'自营订单'}
},
// 服务管理
// 服务列表
{
  name:'serviceList',
  path:'/serviceList',
  component: resolve => require(['@/components/service/serviceList.vue'], resolve),
  meta:{title:'服务列表'}
},
// 设置服务
{
  name:'setService',
  path:'/setService',
  component: resolve => require(['@/components/service/setService.vue'], resolve),
  meta:{title:'服务列表'}
},



//产品管理
{
  name:'transaction',
  path:'/transaction',
  component:resolve => require(['@/components/product/transaction.vue'], resolve),
  meta:{
    title:'公司交易'
  }
},
{
  name:'trademark',
  path:'/trademark',
  component:resolve => require(['@/components/product/trademark.vue'], resolve),
  meta:{
    title:'商标'
  }
},
{
  name:'patent',
  path:'/patent',
  component:resolve => require(['@/components/product/patent.vue'], resolve),
  meta:{
    title:'专利'
  }
},

{
  name:'copyright',
  path:'/copyright',
  component:resolve => require(['@/components/product/copyright.vue'], resolve),
  meta:{
    title:'著作权'
  }
},
{
  name:'InterShop',
  path:'/InterShop',
  component:resolve => require(['@/components/product/InterShop.vue'], resolve),
  meta:{
    title:'网店'
  }
},
{
  name:'newMedia',
  path:'/newMedia',
  component:resolve => require(['@/components/product/newMedia.vue'], resolve),
  meta:{
    title:'新媒体'
  }
},
{
  name:'website',
  path:'/website',
  component:resolve => require(['@/components/product/website.vue'], resolve),
  meta:{
    title:'网站'
  }
},


{
  name:'capitalList',
  path:'/capitalList',
  component:resolve => require(['@/components/capital/capitalList.vue'], resolve),
  meta:{
    title:'资金管理'
  }
},

{
  name:'invoice',
  path:'/invoice',
  component:resolve => require(['@/components/settlement/invoice.vue'], resolve),
  meta:{
    title:'发票管理'
  }
},
{
  name:'refund',
  path:'/refund',
  component:resolve => require(['@/components/capital/refund.vue'], resolve),
  meta:{
    title:'退款'
  }
},

//电话管理
{
  name:'phoneList',
  path:'/phoneList',
  component:resolve => require(['@/components/phone/phoneList.vue'], resolve),
  meta:{
    title:'电话管理'
  }
},





//----------------大笔宁 start----------------------
  // 活动管理
  {
    name:'activity',
    path:'/activity',
    component:resolve => require(['@/components/website/activity.vue'], resolve),
    meta:{
      title:'活动管理'
    }
  },
  // 审核管理
  {
    name:'Audit',
    path:'/Audit',
    component:resolve => require(['@/components/audit/Audit.vue'], resolve),
    meta:{
      title:'审核管理'
    }
  },

  //提现
  {
      name:'withdrawal',
      path:'/withdrawal',
      component:resolve => require(['@/components/audit/withdrawal.vue'], resolve),
      meta:{
        title:'提现审核'
      }
  },

  //分账审核
  {
      name:'splitAccount',
      path:'/splitAccount',
      component:resolve => require(['@/components/audit/splitAccount.vue'], resolve),
      meta:{
        title:'分账审核'
      }
  },


  // 商品审核部分
  {
    name:'commodityAudit',
    path:'/commodityAudit',
    component:resolve => require(['@/components/audit/commodityAudit.vue'], resolve),
    meta:{
      title:'商品审核部分'
    }
  },

  //纠纷单审核
{
      name:'disputeAudit',
      path:'/disputeAudit',
      component:resolve => require(['@/components/audit/disputeAudit.vue'], resolve),
      meta:{
        title:'纠纷单审核'
      }
  },
    //举报审核
{
  name:'report',
  path:'/report',
  component:resolve => require(['@/components/audit/report.vue'], resolve),
  meta:{
    title:'举报审核'
  }
},





   // 服务商列表
   {
    name:'partnerList',
    path:'/partnerList',
    component:resolve => require(['@/components/partner/partnerList.vue'], resolve),
    meta:{
      title:'服务商列表'
    }
  },
  // 服务商冻结列表
{
  name:'partnerFreezen',
  path:'/partnerFreezen',
  component:resolve => require(['@/components/partner/frozen.vue'], resolve),
  meta:{
    title:'服务商冻结列表'
  }
}, 
   // 服务商回收站
   {
    name:'partnerRecycle',
    path:'/partnerRecycle',
    component:resolve => require(['@/components/partner/recycle.vue'], resolve),
    meta:{
      title:'服务商回收站'
    }
  },
//================== 大笔宁  end=========================




//*********************求购*********************
{
  name:'wantbuy',
  path:'/wantbuy',
  component:resolve => require(['@/components/purchase/wantbuy.vue'], resolve),
  meta:{
    title:'求购'
  }
},
{
  name:'wantbuyother',
  path:'/wantbuyother',
  component:resolve => require(['@/components/purchase/wantbuyother.vue'], resolve),
  meta:{
    title:'求购'
  }
},
{
  name:'buyCompany',
  path:'/buyCompany',
  component:resolve => require(['@/components/purchase/buyCompany.vue'], resolve),
  meta:{
    title:'公司求购'
  }
},
{
  name:'buyCopyright',
  path:'/buyCopyright',
  component:resolve => require(['@/components/purchase/buyCopyright.vue'], resolve),
  meta:{
    title:'著作权求购'
  }
},
{
  name:'buyIntershop',
  path:'/buyIntershop',
  component:resolve => require(['@/components/purchase/buyIntershop.vue'], resolve),
  meta:{
    title:'网店求购'
  }
},
{
  name:'buyNewmedia',
  path:'/buyNewmedia',
  component:resolve => require(['@/components/purchase/buyNewmedia.vue'], resolve),
  meta:{
    title:'新媒体求购'
  }
},
{
  name:'buyPatent',
  path:'/buyPatent',
  component:resolve => require(['@/components/purchase/buyPatent.vue'], resolve),
  meta:{
    title:'专利求购'
  }
},
{
  name:'buyTrademark',
  path:'/buyTrademark',
  component:resolve => require(['@/components/purchase/buyTrademark.vue'], resolve),
  meta:{
    title:'商标求购'
  }
},
{
  name:'buyWeb',
  path:'/buyWeb',
  component:resolve => require(['@/components/purchase/buyWeb.vue'], resolve),
  meta:{
    title:'网站求购'
  }
},


//*********************地址商*********************

// 地址商订单列表
{
  name:'addressMerchantList',
  path:'/addressMerchantList',
  component:resolve => require(['@/components/address/merchant.vue'], resolve),
  meta:{
    title:'地址商列表'
  }
},
// 地址商订单列表
{
  name:'addressOrderList',
  path:'/addressOrderList',
  component:resolve => require(['@/components/address/orderList.vue'], resolve),
  meta:{
    title:'地址商订单列表'
  }
},
// 地址商客户列表
{
  name:'addressClientList',
  path:'/addressClientList',
  component:resolve => require(['@/components/address/clientList.vue'], resolve),
  meta:{
    title:'地址商客户列表'
  }
},
// 地址商回收站
{
  name:'addressRecycling',
  path:'/addressRecycling',
  component:resolve => require(['@/components/address/recycling.vue'], resolve),
  meta:{
    title:'地址商回收站'
  }
},
//*********************安全中心*********************

// 取证中心
{
  name:'proof',
  path:'/proof',
  component:resolve => require(['@/components/safety/proof.vue'], resolve),
  meta:{
    title:'取证中心'
  }
},
// 维权中心
{
  name:'protect',
  path:'/protect',
  component:resolve => require(['@/components/safety/protect.vue'], resolve),
  meta:{
    title:'维权中心'
  }
},
// 诉讼中心
{
  name:'lawsuit',
  path:'/lawsuit',
  component:resolve => require(['@/components/safety/lawsuit.vue'], resolve),
  meta:{
    title:'诉讼中心'
  }
},

// 意见反馈
{
  name:'feedback',
  path:'/feedback',
  component:resolve => require(['@/components/website/feedback.vue'], resolve),
  meta:{
    title:'意见反馈'
  }
},
//*********************数据中心*********************

// 数据统计
{
  name:'statistics',
  path:'/statistics',
  component:resolve => require(['@/components/bigData/statistics.vue'], resolve),
  meta:{
    title:'数据统计'
  }
},
// 商品数据统计
{
  name:'goodsChart',
  path:'/goodsChart',
  component:resolve => require(['@/components/bigData/goodsChart.vue'], resolve),
  meta:{
    title:'商品数据'
  }
},
// 财务数据统计
{
  name:'capitalChart',
  path:'/capitalChart',
  component:resolve => require(['@/components/bigData/capitalChart.vue'], resolve),
  meta:{
    title:'财务数据'
  }
},
// 用户数据统计
{
  name:'userChart',
  path:'/userChart',
  component:resolve => require(['@/components/bigData/userChart.vue'], resolve),
  meta:{
    title:'用户数据'
  }
},
// 广告数据统计
{
  name:'advertChart',
  path:'/advertChart',
  component:resolve => require(['@/components/bigData/advertChart.vue'], resolve),
  meta:{
    title:'广告数据'
  }
},
// 订单数据统计
{
  name:'orderChart',
  path:'/orderChart',
  component:resolve => require(['@/components/bigData/orderChart.vue'], resolve),
  meta:{
    title:'订单数据'
  }
},
// 速卖列表
{
  name:'fastSale',
  path:'/fastSale',
  component:resolve => require(['@/components/order/fastSale.vue'], resolve),
  meta:{
    title:'速卖列表'
  }
},
]
export { lazy }



// WEBPACK FOOTER //
// ./src/store/components/lazyLoading.js